export const registerEn = {};
export const registerFr = {};
